import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaphone24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMegaphone24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.967 4.823a.25.25 0 0 0-.384-.211l-4.35 2.77-.184.118H10v5h2.049l.184.117 4.35 2.771a.25.25 0 0 0 .384-.21zM11.612 6H5a3 3 0 0 0-3 3v2c0 1.043.532 1.962 1.34 2.5l1.257 5.867a1.75 1.75 0 0 0 1.711 1.383h.942A1.75 1.75 0 0 0 9 19v-5h2.612l4.165 2.653c1.165.742 2.69-.094 2.69-1.476V4.823c0-1.382-1.525-2.218-2.69-1.476zM5 7.5h3.5v5H5A1.5 1.5 0 0 1 3.5 11V9A1.5 1.5 0 0 1 5 7.5M4.981 14l1.083 5.052a.25.25 0 0 0 .244.198h.942A.25.25 0 0 0 7.5 19v-5zM22 7.603a.75.75 0 0 0-1.5 0v5.151a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaphone24);
